


// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Avatar,
//   Card,
//   CardContent,
//   IconButton,
//   Tooltip,
//   Button,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Stack,
// } from "@mui/material";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddIcon from "@mui/icons-material/Add";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ZoomInIcon from "@mui/icons-material/ZoomIn";
// import ZoomOutIcon from "@mui/icons-material/ZoomOut";
// import RestartAltIcon from "@mui/icons-material/RestartAlt";
// import axios from "axios";
// import api from "../../api/axiosInterceptor";

// const API_BASE_URL = "http://localhost:8000";
// const API_URL = `${API_BASE_URL}/auth/orgchart/`;

// const CARD_WIDTH = 180;
// const H_GAP = 50;
// const CENTER_SPACING = CARD_WIDTH + H_GAP;

// const OrgChartAdmin = () => {
//   const [orgData, setOrgData] = useState([]);
//   const [expanded, setExpanded] = useState({});
//   const [openDialog, setOpenDialog] = useState(false);
//   const [formData, setFormData] = useState({
//     id: null,
//     name: "",
//     designation: "",
//     linkedin_profile: "",
//     parent: null,
//     profile_img: null,
//   });
//   const [zoom, setZoom] = useState(1);

//   // Fetch data
//   const fetchData = async () => {
//     try {
//       const res = await axios.get(API_URL);
//       setOrgData(Array.isArray(res.data) ? res.data : [res.data]);
//     } catch (err) {
//       console.error("Error fetching org data:", err);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   // Zoom handlers
//   const handleZoomIn = () => setZoom((z) => Math.min(z + 0.1, 2));
//   const handleZoomOut = () => setZoom((z) => Math.max(z - 0.1, 0.5));
//   const handleResetZoom = () => setZoom(1);

//   // Dialog
//   const handleOpenDialog = (node = null, parentId = null) => {
//     if (node) {
//       setFormData({
//         id: node.id,
//         name: node.name || "",
//         designation: node.designation || "",
//         linkedin_profile: node.linkedin_profile || "",
//         parent: node.parent || null,
//         profile_img: null,
//       });
//     } else {
//       setFormData({
//         id: null,
//         name: "",
//         designation: "",
//         linkedin_profile: "",
//         parent: parentId || null,
//         profile_img: null,
//       });
//     }
//     setOpenDialog(true);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setFormData({
//       id: null,
//       name: "",
//       designation: "",
//       linkedin_profile: "",
//       parent: null,
//       profile_img: null,
//     });
//   };

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === "profile_img") {
//       setFormData((prev) => ({ ...prev, profile_img: files[0] }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleSubmit = async () => {
//     try {
//       const data = new FormData();
//       for (let key in formData) {
//         if (formData[key] !== null) data.append(key, formData[key]);
//       }
//       if (formData.id) {
//         await api.patch(`${API_URL}${formData.id}/`, data);
//       } else {
//         await api.post(API_URL, data);
//       }
//       handleCloseDialog();
//       fetchData();
//     } catch (err) {
//       console.error("Error saving org unit:", err);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this person?")) {
//       try {
//         await api.delete(`${API_URL}${id}/`);
//         fetchData();
//       } catch (err) {
//         console.error("Error deleting org unit:", err);
//       }
//     }
//   };

//   const toggleExpand = (id) => {
//     setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   const OrgNode = ({ node, level = 0 }) => {
//     const children = node.subordinates || [];
//     const isOpen = expanded[node.id] || false;
//     const childCount = children.length;

//     const childrenSpan = childCount > 1 ? (childCount - 1) * CENTER_SPACING : 0;
//     const lineLeftOffset =
//       childCount > 0 ? `calc(50% - ${childrenSpan / 2}px)` : "50%";
//     const lineWidth = childCount > 1 ? `${childrenSpan}px` : "0px";

//     return (
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           position: "relative",
//           cursor: "default",
//           userSelect: "none",
//         }}
//       >
//         <Card
//           sx={{
//             width: `${CARD_WIDTH}px`,
//             textAlign: "center",
//             borderRadius: 2,
//             borderTop:
//               level === 0
//                 ? "4px solid #a259ff"
//                 : level === 1
//                 ? "4px solid #03a9f4"
//                 : "4px solid #00bcd4",
//             boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
//             backgroundColor: "#fff",
//             transition: "transform 0.16s ease",
//             "&:hover": { transform: "scale(1.02)" },
//           }}
//         >
//           <CardContent sx={{ pb: 1 }}>
//             <Avatar
//               src={node.profile_img || ""}
//               alt={node.name}
//               sx={{
//                 width: 60,
//                 height: 60,
//                 margin: "0 auto 8px",
//                 backgroundColor: "#d9d9d9",
//                 fontSize: 20,
//                 fontWeight: 700,
//               }}
//             >
//               {!node.profile_img && (node.name?.charAt(0) || "U")}
//             </Avatar>

//             <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
//               {node.name}
//             </Typography>
//             <Typography variant="body2" sx={{ color: "#777", mt: 0.4 }}>
//               {node.designation}
//             </Typography>

//             <Box
//               sx={{
//                 mt: 1,
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 gap: 0.5,
//               }}
//             >
//               {node.linkedin_profile && (
//                 <Tooltip title="LinkedIn">
//                   <IconButton
//                     size="small"
//                     href={node.linkedin_profile}
//                     target="_blank"
//                     onClick={(e) => e.stopPropagation()}
//                   >
//                     <LinkedInIcon fontSize="small" color="primary" />
//                   </IconButton>
//                 </Tooltip>
//               )}
//               {children.length > 0 && (
//                 <IconButton
//                   size="small"
//                   onClick={() => toggleExpand(node.id)}
//                   aria-label={isOpen ? "collapse" : "expand"}
//                 >
//                   <ExpandMoreIcon
//                     sx={{
//                       transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
//                       transition: "transform 0.25s ease",
//                       color: "#555",
//                     }}
//                   />
//                 </IconButton>
//               )}
//               <Tooltip title="Edit">
//                 <IconButton size="small" onClick={() => handleOpenDialog(node)}>
//                   <EditIcon fontSize="small" color="action" />
//                 </IconButton>
//               </Tooltip>
//               <Tooltip title="Delete">
//                 <IconButton size="small" onClick={() => handleDelete(node.id)}>
//                   <DeleteIcon fontSize="small" color="error" />
//                 </IconButton>
//               </Tooltip>
//               <Tooltip title="Add Subordinate">
//                 <IconButton
//                   size="small"
//                   onClick={() => handleOpenDialog(null, node.id)}
//                 >
//                   <AddIcon fontSize="small" color="success" />
//                 </IconButton>
//               </Tooltip>
//             </Box>
//           </CardContent>
//         </Card>

//         {/* Vertical connector */}
//         {childCount > 0 && isOpen && (
//           <Box
//             sx={{ width: "2px", height: 24, backgroundColor: "#d8d8d8", mt: 1 }}
//           />
//         )}

//         {/* Children row */}
//         {childCount > 0 && isOpen && (
//           <Box
//             sx={{
//               position: "relative",
//               mt: 1.5,
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "flex-start",
//             }}
//           >
//             {childCount > 1 ? (
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: -16,
//                   left: lineLeftOffset,
//                   height: "2px",
//                   width: lineWidth,
//                   backgroundColor: "#d8d8d8",
//                 }}
//               />
//             ) : (
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: -16,
//                   left: `calc(50% - 12px)`,
//                   height: "2px",
//                   width: "24px",
//                   backgroundColor: "#d8d8d8",
//                 }}
//               />
//             )}

//             {children.map((child) => (
//               <Box
//                 key={child.id}
//                 sx={{
//                   position: "relative",
//                   mx: `${H_GAP / 2}px`,
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     top: -16,
//                     left: "50%",
//                     transform: "translateX(-50%)",
//                     width: "2px",
//                     height: "18px",
//                     backgroundColor: "#d8d8d8",
//                   }}
//                 />
//                 <OrgNode node={child} level={level + 1} />
//               </Box>
//             ))}
//           </Box>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <Box
//       sx={{
//         p: 4,
//         background: "#fff",
//         minHeight: "100vh",
//         overflowX: "auto",
//         overflowY: "visible",
//         width: "100%",
//         position: "relative",
//       }}
//     >
//       <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
//         Org Chart Admin
//       </Typography>

//       {/* Toolbar */}
//       <Stack
//         direction="row"
//         spacing={1}
//         sx={{
//           mb: 3,
//           position: "sticky",
//           top: 8,
//           backgroundColor: "#fff",
//           zIndex: 10,
//           borderRadius: "8px",
//           boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
//           p: 0.5,
//         }}
//       >
//         <Tooltip title="Add Root Member">
//           <Button
//             variant="contained"
//             startIcon={<AddIcon />}
//             onClick={() => handleOpenDialog(null, null)}
//           >
//             Add Root
//           </Button>
//         </Tooltip>

//         <Tooltip title="Zoom In">
//           <IconButton onClick={handleZoomIn}>
//             <ZoomInIcon />
//           </IconButton>
//         </Tooltip>
//         <Tooltip title="Zoom Out">
//           <IconButton onClick={handleZoomOut}>
//             <ZoomOutIcon />
//           </IconButton>
//         </Tooltip>
//         <Tooltip title="Reset Zoom">
//           <IconButton onClick={handleResetZoom}>
//             <RestartAltIcon />
//           </IconButton>
//         </Tooltip>
//       </Stack>

//       {/* Chart container */}
//       <Box
//         sx={{
//           display: "inline-flex",
//           justifyContent: "center",
//           position: "relative",
//           minWidth: "max-content",
//           transform: `scale(${zoom})`,
//           transformOrigin: "top center",
//           transition: "transform 0.2s ease-in-out",
//         }}
//       >
//         {orgData.map((root) => (
//           <OrgNode key={root.id} node={root} />
//         ))}
//       </Box>

//       {/* Dialog */}
//       <Dialog open={openDialog} onClose={handleCloseDialog}>
//         <DialogTitle>{formData.id ? "Edit Member" : "Add Member"}</DialogTitle>
//         <DialogContent
//           sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
//         >
//           <TextField
//             name="name"
//             label="Name"
//             value={formData.name}
//             onChange={handleChange}
//             fullWidth
//           />
//           <TextField
//             name="designation"
//             label="Designation"
//             value={formData.designation}
//             onChange={handleChange}
//             fullWidth
//           />
//           <TextField
//             name="linkedin_profile"
//             label="LinkedIn URL"
//             value={formData.linkedin_profile}
//             onChange={handleChange}
//             fullWidth
//           />
//           <input
//             type="file"
//             name="profile_img"
//             onChange={handleChange}
//             accept="image/*"
//             style={{ marginTop: "8px" }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDialog}>Cancel</Button>
//           <Button variant="contained" onClick={handleSubmit}>
//             {formData.id ? "Update" : "Create"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default OrgChartAdmin;



import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
} from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import axios from "axios";
import api from "../../api/axiosInterceptor";
import { API_BASE_URL } from "../../config";

// const API_BASE_URL = "http://localhost:8000";
const API_URL = `/auth/orgchart/`;

const CARD_WIDTH = 180;
const H_GAP = 50;
const CENTER_SPACING = CARD_WIDTH + H_GAP;

const OrgChartAdmin = () => {
  const [orgData, setOrgData] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    designation: "",
    linkedin_profile: "",
    parent: null,
    profile_img: null,
  });
  const [zoom, setZoom] = useState(1);

  // Fetch data
  const fetchData = async () => {
    try {
      const res = await axios.get(API_URL);
      setOrgData(Array.isArray(res.data) ? res.data : [res.data]);
    } catch (err) {
      console.error("Error fetching org data:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Zoom handlers
  const handleZoomIn = () => setZoom((z) => Math.min(z + 0.1, 2));
  const handleZoomOut = () => setZoom((z) => Math.max(z - 0.1, 0.5));
  const handleResetZoom = () => setZoom(1);

  // Dialog
  const handleOpenDialog = (node = null, parentId = null) => {
    if (node) {
      setFormData({
        id: node.id,
        name: node.name || "",
        designation: node.designation || "",
        linkedin_profile: node.linkedin_profile || "",
        parent: node.parent || null,
        profile_img: null,
      });
    } else {
      setFormData({
        id: null,
        name: "",
        designation: "",
        linkedin_profile: "",
        parent: parentId || null,
        profile_img: null,
      });
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setFormData({
      id: null,
      name: "",
      designation: "",
      linkedin_profile: "",
      parent: null,
      profile_img: null,
    });
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "profile_img") {
      setFormData((prev) => ({ ...prev, profile_img: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async () => {
    try {
      const data = new FormData();
      for (let key in formData) {
        if (formData[key] !== null) data.append(key, formData[key]);
      }
      if (formData.id) {
        await api.patch(`${API_URL}${formData.id}/`, data);
      } else {
        await api.post(API_URL, data);
      }
      handleCloseDialog();
      fetchData();
    } catch (err) {
      console.error("Error saving org unit:", err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this person?")) {
      try {
        await api.delete(`${API_URL}${id}/`);
        fetchData();
      } catch (err) {
        console.error("Error deleting org unit:", err);
      }
    }
  };

  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const OrgNode = ({ node, level = 0 }) => {
    const children = node.subordinates || [];
    const isOpen = expanded[node.id] || false;
    const childCount = children.length;

    const childrenSpan = childCount > 1 ? (childCount - 1) * CENTER_SPACING : 0;
    const lineLeftOffset =
      childCount > 0 ? `calc(50% - ${childrenSpan / 2}px)` : "50%";
    const lineWidth = childCount > 1 ? `${childrenSpan}px` : "0px";

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          cursor: "default",
          userSelect: "none",
          minWidth: "max-content",
        }}
      >
        <Card
          sx={{
            width: `${CARD_WIDTH}px`,
            textAlign: "center",
            borderRadius: 2,
            borderTop:
              level === 0
                ? "4px solid #a259ff"
                : level === 1
                ? "4px solid #03a9f4"
                : "4px solid #00bcd4",
            boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
            backgroundColor: "#fff",
            transition: "transform 0.16s ease",
            flexShrink: 0,
            "&:hover": { transform: "scale(1.02)" },
          }}
        >
          <CardContent sx={{ pb: 1 }}>
            <Avatar
              src={node.profile_img || ""}
              alt={node.name}
              sx={{
                width: 60,
                height: 60,
                margin: "0 auto 8px",
                backgroundColor: "#d9d9d9",
                fontSize: 20,
                fontWeight: 700,
              }}
            >
              {!node.profile_img && (node.name?.charAt(0) || "U")}
            </Avatar>

            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              {node.name}
            </Typography>
            <Typography variant="body2" sx={{ color: "#777", mt: 0.4 }}>
              {node.designation}
            </Typography>

            <Box
              sx={{
                mt: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              {node.linkedin_profile && (
                <Tooltip title="LinkedIn">
                  <IconButton
                    size="small"
                    href={node.linkedin_profile}
                    target="_blank"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <LinkedInIcon fontSize="small" color="primary" />
                  </IconButton>
                </Tooltip>
              )}
              {children.length > 0 && (
                <IconButton
                  size="small"
                  onClick={() => toggleExpand(node.id)}
                  aria-label={isOpen ? "collapse" : "expand"}
                >
                  <ExpandMoreIcon
                    sx={{
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.25s ease",
                      color: "#555",
                    }}
                  />
                </IconButton>
              )}
              <Tooltip title="Edit">
                <IconButton size="small" onClick={() => handleOpenDialog(node)}>
                  <EditIcon fontSize="small" color="action" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton size="small" onClick={() => handleDelete(node.id)}>
                  <DeleteIcon fontSize="small" color="error" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Add Subordinate">
                <IconButton
                  size="small"
                  onClick={() => handleOpenDialog(null, node.id)}
                >
                  <AddIcon fontSize="small" color="success" />
                </IconButton>
              </Tooltip>
            </Box>
          </CardContent>
        </Card>

        {/* Vertical connector */}
        {childCount > 0 && isOpen && (
          <Box
            sx={{ 
              width: "2px", 
              height: 24, 
              backgroundColor: "#d8d8d8", 
              mt: 1,
              flexShrink: 0,
            }}
          />
        )}

        {/* Children row */}
        {childCount > 0 && isOpen && (
          <Box
            sx={{
              position: "relative",
              mt: 1.5,
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              width: "max-content",
              minWidth: "100%",
            }}
          >
            {/* Horizontal connector */}
            {childCount > 1 ? (
              <Box
                sx={{
                  position: "absolute",
                  top: -16,
                  left: lineLeftOffset,
                  height: "2px",
                  width: lineWidth,
                  backgroundColor: "#d8d8d8",
                  zIndex: 0,
                  borderRadius: "1px",
                }}
              />
            ) : (
              <Box
                sx={{
                  position: "absolute",
                  top: -16,
                  left: `calc(50% - 12px)`,
                  height: "2px",
                  width: "24px",
                  backgroundColor: "#d8d8d8",
                  zIndex: 0,
                  borderRadius: "1px",
                }}
              />
            )}

            {children.map((child) => (
              <Box
                key={child.id}
                sx={{
                  position: "relative",
                  mx: `${H_GAP / 2}px`,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  zIndex: 1,
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: -16,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "2px",
                    height: "18px",
                    backgroundColor: "#d8d8d8",
                  }}
                />
                <OrgNode node={child} level={level + 1} />
              </Box>
            ))}
          </Box>
        )}
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 4,
        width: "95%",
        height: "100vh",
        overflow: "hidden",
        background: "#fff",
        position: "relative",
      }}
    >
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
        Org Chart Admin
      </Typography>

      {/* Toolbar */}
      <Stack
        direction="row"
        spacing={1}
        sx={{
          mb: 2,
          position: "sticky",
          top: 16,
          backgroundColor: "#fff",
          zIndex: 10,
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          p: 0.5,
        }}
      >
        <Tooltip title="Add Root Member">
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => handleOpenDialog(null, null)}
          >
            Add Root
          </Button>
        </Tooltip>

        <Tooltip title="Zoom In">
          <IconButton onClick={handleZoomIn}>
            <ZoomInIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Zoom Out">
          <IconButton onClick={handleZoomOut}>
            <ZoomOutIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Reset Zoom">
          <IconButton onClick={handleResetZoom}>
            <RestartAltIcon />
          </IconButton>
        </Tooltip>
      </Stack>

      {/* Main chart container with proper scrolling */}
      <Box
        sx={{
          width: "100%",
          flex: 1,
          overflow: "auto",
          border: "1px solid #f0f0f0",
          borderRadius: 1,
          backgroundColor: "#fafafa",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            minHeight: "100%",
            minWidth: "max-content",
            p: 4,
          }}
        >
          {/* Zoom container */}
          <Box
            sx={{
              display: "inline-flex",
              justifyContent: "center",
              position: "relative",
              minWidth: "max-content",
              transform: `scale(${zoom})`,
              transformOrigin: "top center",
              transition: "transform 0.2s ease-in-out",
            }}
          >
            {orgData.map((root) => (
              <OrgNode key={root.id} node={root} />
            ))}
          </Box>
        </Box>
      </Box>

      {/* Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>{formData.id ? "Edit Member" : "Add Member"}</DialogTitle>
        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
        >
          <TextField
            name="name"
            label="Name"
            value={formData.name}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            name="designation"
            label="Designation"
            value={formData.designation}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            name="linkedin_profile"
            label="LinkedIn URL"
            value={formData.linkedin_profile}
            onChange={handleChange}
            fullWidth
          />
          <input
            type="file"
            name="profile_img"
            onChange={handleChange}
            accept="image/*"
            style={{ marginTop: "8px" }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            {formData.id ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default OrgChartAdmin;